import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { ApiService, showToast } from './api.service';

export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const api = inject(ApiService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const failedToken = (req.headers.get('Authorization') || '').replace(/^Bearer\s+/i, '');
      const currentToken = api.accessToken();
      if (error.status === 401 && failedToken && failedToken === currentToken && !router.url.startsWith('/login') && !router.url.startsWith('/otp')) {
        api.logout();
        showToast('error', 'Your login has expired. Please sign in again, then retry the action.');
        router.navigate(['/login'], { queryParams: { expired: '1' } });
      }

      return throwError(() => error);
    })
  );
};
